import { useEffectivePermissions } from '#pplx/frontend/apps/ask/organization/hooks/useEffectivePermissions.js';
export const ORG_PLUGIN_MANAGEMENT_PERMISSION_ID = 'org_skills_configure';
// The single FE predicate for org-plugin management authority, mirroring
// skillservice's verifyOrgManagementWrite with pluginSpec: the
// `org_skills_configure` permission decides, with no entitlement-mode or
// legacy org-admin arm — the backend enforces the permission unconditionally,
// and admins hold it through the seeded Admin role grant. Every org plugin
// management surface must derive from this hook so UI visibility cannot
// drift from what the backend allows.
export function useCanManageOrgPlugins(reason, 
// Defaults to enabled. Pass false where the answer is not consulted, so a surface that has no
// organization layer does not pay for an RBAC request it will ignore.
{ enabled = true } = {}) {
    const { permissions, isLoading } = useEffectivePermissions({ reason, enabled });
    return {
        canManageOrgPlugins: permissions.has(ORG_PLUGIN_MANAGEMENT_PERMISSION_ID),
        loading: isLoading,
    };
}
//# sourceMappingURL=useCanManageOrgPlugins.js.map